import PhoneCountryCodes, { SANCTIONED_PHONE_COUNTRY_CODES_SET } from './phoneCountryCodes';

export type PhoneCountryCodeOptionsProps = {
  shortCode?: boolean;
  disallowSanctionedCodes?: boolean;
};

export function PhoneCountryCodeOptions({ shortCode, disallowSanctionedCodes }: PhoneCountryCodeOptionsProps) {
  return (
    <>
      {PhoneCountryCodes.map(({ phone, iso, name }) => (
        <option key={`${phone} ${iso}`} value={`${phone} ${iso}`} disabled={disallowSanctionedCodes && SANCTIONED_PHONE_COUNTRY_CODES_SET.has(phone)}>
          {shortCode ? iso : name}&nbsp;{phone}
        </option>
      ))}
    </>
  );
}
